import { Icon } from '../../icon';
import { Button } from '../../shadcn/button';
import { ButtonGroup } from '../../shadcn/button-group';

export const Zoom = ({ handleZoomOut, handleZoomIn }: { handleZoomOut: () => void; handleZoomIn: () => void }) => {
  return (
    <ButtonGroup>
      <Button size="iconSm" onClick={handleZoomOut} variant="blue">
        <Icon className="lucide--zoom-out" />
      </Button>
      <Button size="iconSm" onClick={handleZoomIn} variant="blue">
        <Icon className="lucide--zoom-in" />
      </Button>
    </ButtonGroup>
  );
};
